import { isDOM } from '@app/shared/predicates'
import { createApp } from '@app/adapters/create-app'
import AssistantChecksFilters from '@app/application/sf-assistant-checks/components/assistant-checks-filters.vue'

window.onDomLoad(function ($doc) {
  const doc = $doc[0]

  if (!isDOM(doc)) {
    return
  }

  const banner = document.querySelector(
    '[data-behaviour="sf-assistant-checks-filters"]'
  )

  if (banner) {
    createApp(
      AssistantChecksFilters,
      {
        usersOptions: $(banner).data('users'),
      },
      {
        singletonId: 'sf-assistant-checks-filters',
      }
    ).mount(banner)
  }
})
